import { QueryKey } from "@/api";
import { Api } from "@/api/Api";
import { useQuery } from "@tanstack/react-query";

export type AlertSubscriptionLocation = {
  location_label?: string | null;
  location_lat?: number | null;
  location_lon?: number | null;
  location_polygon?: unknown;
  polygon?: unknown;
  geometry?: unknown;
};

export type AlertSubscriptionDetails = {
  name: string;
  is_active: boolean;
  execution_frequency: number;
  language?: string;
  locations?: AlertSubscriptionLocation[];
  triggers?: unknown[];
};

export function fetchAlertSubscription(subscriptionId: string): Promise<AlertSubscriptionDetails> {
  return Api.alert.v2GetAlertSubscription({ subscriptionId }) as Promise<AlertSubscriptionDetails>;
}

export function useAlertSubscription(subscriptionId: string | undefined) {
  const { data, isLoading, error } = useQuery<AlertSubscriptionDetails, Error>(
    [QueryKey.ALERT_SUBSCRIPTION, subscriptionId],
    () => {
      if (!subscriptionId) {
        throw new Error("A subscription ID is required");
      }
      return fetchAlertSubscription(subscriptionId);
    },
    {
      enabled: Boolean(subscriptionId),
      staleTime: 60_000,
    },
  );

  return { subscription: data, isLoading, error };
}
